import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { ApiError, api, keys, unwrap } from '@/api';
import { Button, Field, Input } from '@/components/ui';
import { SPACE_LABEL } from '@/lib/space';

export function Login() {
	const qc = useQueryClient();
	const [password, setPassword] = useState('');
	const [error, setError] = useState<string>();
	const [busy, setBusy] = useState(false);
	return (
		<div className="grid min-h-dvh place-items-center px-4">
			<form
				className="flex w-full max-w-sm flex-col gap-4 rounded-xl border border-border bg-surface p-6 shadow-sm"
				onSubmit={async (e) => {
					e.preventDefault();
					setBusy(true);
					try {
						await unwrap(api.POST('/api/v1/session', { body: { password } }));
						await qc.invalidateQueries({ queryKey: keys.session });
					} catch (err) {
						setError(err instanceof ApiError ? err.message : 'Could not reach the server');
					} finally {
						setBusy(false);
					}
				}}
			>
				<div className="flex items-center gap-2">
					<img src="/favicon.svg" alt="" className="size-7" />
					<h1 className="text-lg font-semibold">Mock Sensors · {SPACE_LABEL}</h1>
				</div>
				<Field label="Admin password" error={error}>
					<Input type="password" autoFocus autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
				</Field>
				<Button variant="primary" type="submit" disabled={busy || !password}>
					Log in
				</Button>
			</form>
		</div>
	);
}
